import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';

import { ConnectedDocumentService } from './connected-document-base.service';
import { ContactDocument } from '../../model/contact-document';

@Injectable()
export class ContactDocumentService extends ConnectedDocumentService<ContactDocument> {
  constructor(client: HttpClient,
      messageService: MessageService,
      progressBar: ProgressBarService,
      @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, messageService, progressBar, 'contact-documents', config);
  }

  createModel(): ContactDocument {
    return new ContactDocument();
  }
}
